import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import moment from 'moment';
import FMPHeadline from '../../components/ui/FMPHeadline';
import Button from '@material-ui/core/Button';
import StationInvoicesContainer from '../../containers/accounting/StationInvoices';
import BulkInvoicesContainer from '../../containers/accounting/BulkInvoices';
import BulkCustomersContainer from '../../containers/logistics/BulkCustomers';
import StationsContainer from '../../containers/Stations';
import CarriersContainer from '../../containers/logistics/Carriers';
import TerminalsContainer from '../../containers/logistics/Terminals';
import SuppliersContainer from '../../containers/logistics/Suppliers';

import FMPDatePicker from '../../components/pureForm/FMPDatePicker';
import invoiceIcon from '../../images/invoicePdf.svg';
import quickbooksLogo from '../../images/quickbooksLogo.svg';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormComponent from '../../components/FormComponent';

import DownloadIcon from '@material-ui/icons/CloudDownload';
import IconButton from '@material-ui/core/IconButton';
import Popover from '@material-ui/core/Popover';

import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import CloseIcon from '@material-ui/icons/Close';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Slide from '@material-ui/core/Slide';
import { green } from '@material-ui/core/colors';
import orange from '@material-ui/core/colors/orange';
import { getSharedStyles } from '../../themes';
import AuthUserContainer from '../../containers/AuthUser';
import FMPTerminalMultiSelect from '../../components/pureForm/FMPTerminalMultiSelect';
import { ingestedTerminalIds } from './constants';
import FMPCheckbox from '../../components/pureForm/FMPCheckbox';
export const isLocalhost = Boolean(window.location.hostname === 'localhost');
const SlideUpTransition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const styles = (theme) => {
	return {
		...getSharedStyles(theme),
		bigButton: {
			borderRadius: '100px',
			padding: '18px 34px',
			fontSize: 16,
		},
		smallButton: {
			borderRadius: '100px',
			fontWeight: 200,
		},
		pickPlease: {
			background: '#F7F7F7',
			border: '1px solid #DDDDDD',
			padding: 20,
			color: '#666',
		},
		divider: {
			borderBottom: '1px dashed #dddddd',
			marginBottom: 25,
			marginTop: 25,
		},
		stats: {
			padding: '20px 10px 20px 10px',
			borderBottom: '1px solid #ddd',
			marginBottom: 10,
		},
		statGroup: {
			padding: '5px 5px 10px 5px',
			borderBottom: '1px solid #eee',
			marginBottom: 10,
		},
		available: {
			fontWeight: 900,
		},
		invoiceDocument: {
			position: 'absolute',
		},
		invoiceDocumentContainer: {
			position: 'relative',
			display: 'flex',
			alignItems: 'center',
		},
		invoiceIcon: {
			display: 'inline-block',
			width: 40,
			height: 48,
			backgroundImage: `url('${invoiceIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'relative',
			flexShrink: 0,
			cursor: 'pointer',
		},
		quickbooksIcon: {
			display: 'inline-block',
			width: 40,
			height: 40,
			backgroundImage: `url('${quickbooksLogo}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'relative',
			flexShrink: 0,
			cursor: 'pointer',
		},
		table: {
			width: '100%',
			tableLayout: 'auto',
		},
		row: {
			cursor: 'pointer',
		},
		button: {
			verticalAlign: 'middle',
			padding: '8px 10px',
		},
		resultsHere: {
			padding: 30,
			backgroundColor: '#f1f1f1',
			color: '#777',
			borderRadius: 10,
		},
		runningSearch: {
			paddingLeft: 5,
			display: 'flex',
			alignItems: 'center',
			fontSize: 16,
			color: '#666',
		},
		dateRange: {
			marginRight: 10,
		},
		icon: {
			marginRight: 5,
		},
		linkedItem: {
			fontSize: 14,
			textDecoration: 'none',
			display: 'flex',
			alignItems: 'center',
		},
		openLink: {
			paddingLeft: 4,
			width: 14,
			height: 14,
		},
		diffError: {
			fontWeight: 900,
			color: '#FF500F',
		},
		contractSub: {
			paddingLeft: 10,
			fontSize: 14,
			color: '#666',
		},
		todo: {
			border: `1px solid #bbb`,
			color: '#666',
			padding: 5,
			fontStyle: 'italic',
		},
		addButton: {
			verticalAlign: 'middle',
			textDecoration: 'none',
			marginBottom: 10,
			borderRadius: 100,
		},
		fuelGroup: {
			marginBottom: 7,
		},
		savedSearchHelp: {
			padding: 10,
			color: '#444',
			backgroundColor: '#f7f7f7',
			border: '1px solid #eee',
			marginTop: 5,
			fontWeight: 200,
			marginBottom: 10,
		},
		saveNewSearchSection: {
			//borderTop : '1px solid #d7d7d7',
			marginTop: 20,
			paddingTop: 10,
		},
		noSavedSearches: {
			color: '#666',
			padding: 5,
			fontStyle: 'italic',
		},
		savedSearchContainer: {
			marginTop: 10,
			paddingTop: 10,
			borderBottom: '1px solid #d7d7d7',
			marginBottom: 10,
			paddingBottom: 5,
			display: 'flex',
			justifyContent: 'space-between',
		},
		addedOn: {
			fontSize: '85%',
			fontWeight: 200,
			color: '#666',
			paddingTop: 3,
		},
		snackbarSuccess: {
			backgroundColor: green[600],
		},
		snackbarIcon: {
			opacity: 0.9,
			marginRight: theme.spacing(1),
			fontSize: 20,
		},
		snackbarMessage: {
			display: 'flex',
			alignItems: 'center',
		},
		cancelled: {
			color: orange[500],
			fontWeight: 900,
		},
		popOverPaper: {
			textAlign: 'left',
			boxSizing: 'border-box',
			padding: 20,
		},
		commentsContainer: {
			padding: 7,
			display: 'inline-block',
			fontSize: '95%',
		},
		commentDateTime: {
			fontSize: '80%',
			color: '#666',
		},
		popover: {
			pointerEvents: 'none',
		},
	};
};

class RailcarSearch extends FormComponent {
	constructor(props) {
		super(props);

		this.state = {
			formFieldError: {},
			isSearching: false,
			terminalIds: ingestedTerminalIds,
			afterDate: moment().subtract(3, 'months').format('YYYY-MM-DD'),
			beforeDate: moment().add(2, 'months').format('YYYY-MM-DD'),
			noDeliveryFormat: false,
		};
	}

	componentDidMount() {
		//- Only used for updates
		const { terminals, searchTerminals } = this.props;

		if (_.isEmpty(terminals)) {
			searchTerminals();
		}
	}

	getApiParams = () => {
		const { accessToken } = this.props;

		const { afterDate, beforeDate, terminalIds, noDeliveryFormat } = this.state;

		const afterMoment = moment(afterDate);
		const beforeMoment = moment(beforeDate);

		const params = {
			accessToken,
			terminalIds,
			afterDate: afterMoment.format('YYYY-MM-DD'),
			beforeDate: beforeMoment.format('YYYY-MM-DD'),
			noDeliveryFormat: noDeliveryFormat ? true : false,
		};
		return params;
	};

	handleSnackbarClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		this.setState({ snackbarIsOpen: false });
	};

	handleCommentPopoverOpen = (event, internalNote) => {
		this.setState({
			popoverComment: internalNote,
			commentPopoverAnchor: event.currentTarget,
		});
	};
	handleCommentPopoverClose = () => {
		this.setState({ commentPopoverAnchor: null });
	};

	render() {
		const { classes } = this.props;
		return (
			<Grid container spacing={2}>
				<Grid item md={12} xs={12}>
					{this.renderSearch()}
				</Grid>

				<Snackbar
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'right',
					}}
					open={this.state.snackbarIsOpen}
					autoHideDuration={2000}
					onClose={this.handleSnackbarClose}
					TransitionComponent={SlideUpTransition}
				>
					<SnackbarContent
						className={classes.snackbarSuccess}
						aria-describedby="client-snackbar"
						message={
							<span id="client-snackbar" className={classes.snackbarMessage}>
								<CheckCircleIcon className={classes.snackbarIcon} />
								<strong>{this.state.snackbarMessage} </strong>
							</span>
						}
						action={[
							<IconButton
								key="close"
								aria-label="close"
								color="inherit"
								onClick={this.handleSnackbarClose}
							>
								<CloseIcon className={classes.icon} />
							</IconButton>,
						]}
					/>
				</Snackbar>

				<Popover
					id="comment-popover"
					className={classes.popover}
					classes={{ paper: classes.popOverPaper }}
					open={!!this.state.commentPopoverAnchor}
					anchorEl={this.state.commentPopoverAnchor}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
					onClose={this.state.handleCommentPopoverClose}
					disableRestoreFocus
				>
					<div className={classes.commentsContainer}>
						{!!this.state.popoverComment && <div>{this.state.popoverComment}</div>}
					</div>
				</Popover>
			</Grid>
		);
	}

	renderSearch() {
		const { classes } = this.props;
		const { stationFormatErrors } = this.state;

		return (
			<>
				<FMPHeadline label="Railcar Search & Export" />
				<Paper className={classes.paper}>
					<Grid container spacing={2}>
						{this.renderAllSearchOptions()}
						{this.renderSubmitButtons()}
					</Grid>
				</Paper>

				{!_.isEmpty(stationFormatErrors) && this.renderErrors(stationFormatErrors)}
			</>
		);
	}
	renderSubmitButtons = () => {
		const { classes } = this.props;
		const { isSearching } = this.state;

		const { isExternalReporting } = this.props;
		const params = this.getApiParams();
		params.downloadCsv = true;
		//- Externals use the locked-down export endpoint: always CSV, always
		//- no-delivery-format, always LF Energy cars only (enforced server-side).
		const request = {
			method: isExternalReporting ? 'railcars.export.get' : 'railcars.masterSheet.get',
			params,
		};

		let host = '';
		if (isLocalhost) {
			host = 'http://localhost:3700';
		}
		const downloadUrl = `${host}/api?request=${JSON.stringify(request)}`;

		return (
			<Grid container spacing={2}>
				<Grid item md={12} style={{ paddingTop: 25, display: 'flex' }}>
					<a
						href={downloadUrl}
						style={{ textDecoration: 'none', paddingRight: 5 }}
						target="_blank"
						rel="noreferrer noopener"
					>
						<Button
							className={classes.bigButton}
							variant="contained"
							color="primary"
							style={{ marginLeft: 10 }}
							disabled={isSearching}
						>
							<DownloadIcon className={classes.icon} />
							Search & Download
						</Button>
					</a>

					{isSearching && (
						<div className={classes.runningSearch}>
							<CircularProgress />
							<span style={{ paddingLeft: 5 }}>Searching...</span>
						</div>
					)}
				</Grid>
			</Grid>
		);
	};

	renderAllSearchOptions = () => {
		const { terminals, isExternalReporting } = this.props;

		const filteredTerminals = terminals.filter((t) =>
			_.includes(ingestedTerminalIds, t.terminalId)
		);

		return (
			<>
				<FMPTerminalMultiSelect
					{...this.setForm('terminalIds', 'Terminals', false, [])}
					terminals={filteredTerminals}
				/>

				<FMPDatePicker
					{...this.setForm('afterDate', 'Delivery Date After', true)}
					format={'MMMM Do, YYYY'}
					md={6}
				/>

				<FMPDatePicker
					{...this.setForm('beforeDate', 'Delivery Date Before', true)}
					format={'MMMM Do, YYYY'}
					md={6}
				/>

				{!isExternalReporting && (
					<FMPCheckbox {...this.setForm('noDeliveryFormat', 'No Delivery Format', true)} md={5} />
				)}

				<div style={{ padding: '20px', border: '1px solid #eee', fontSize: '90%' }}>
					<div>
						Note on how the Delivery Date After / Before filters works:
						<br />
						<br />
						<strong>Deliveries:</strong>
						<br />• Includes deliveries with a start window after the <em>After</em> date.
						<br />• Includes deliveries with an end window before the <em>Before</em> date.
						<br />
						<br />
						<strong>Railcars:</strong>
						<br />• Includes railcars with an <strong>AP date</strong> after the <em>After</em> date
						or before the <em>Before</em> date.
						<br />
						<br />
						Once these sets are collected, the system matches deliveries and railcars and returns
						the combined results.
						<br />
						<br />
						⚠️ <strong>Note:</strong> Railcars may be returned without associated deliveries if
						their AP date falls within the specified range and they don&apos;t have any associated
						deliveries yet.
					</div>
				</div>
			</>
		);
	};
}

RailcarSearch.propTypes = {
	classes: PropTypes.object.isRequired,
	showErrors: PropTypes.func.isRequired,
	history: PropTypes.object,
	canMakeUpdates: PropTypes.bool,

	terminals: PropTypes.array,
	searchTerminals: PropTypes.func.isRequired,

	accessToken: PropTypes.string,

	stationMap: PropTypes.object,
	carrierMap: PropTypes.object,
	invoiceDocumentMap: PropTypes.object,
	stationDeliveryMap: PropTypes.object,
	terminalMap: PropTypes.object,
	supplierMap: PropTypes.object,
	bulkCustomerMap: PropTypes.object,
	bulkDeliveryMap: PropTypes.object,
	resourceMap: PropTypes.object,

	isExternalLogistics: PropTypes.bool.isRequired,
	isExternalReporting: PropTypes.bool,
};

export default _.flow([
	withStyles(styles),
	StationInvoicesContainer,
	BulkInvoicesContainer,
	BulkCustomersContainer,
	StationsContainer,
	CarriersContainer,
	TerminalsContainer,
	SuppliersContainer,
	AuthUserContainer,
])(RailcarSearch);
